<template>

  <section id="politica" class="d-flex align-items-center politica">

      <div class="container">

        <div class="row">

          <div class="icon-box" data-aos="fade-up" data-aos-delay="200">

            <div class="d-flex justify-content-start flex-fill mb-4" data-aos="fade-right" data-aos-delay="150">
              <a href="/">
                <img src="../assets/img/logo.png" alt="" class="img-fluid" style="width: 180px; margin-left: -7px;">
              </a>
            </div>

            <div class="col-lg-12 d-flex flex-column justify-content-center mb-4">

              <h3 class="pb-2 text-center" data-aos="fade-up">POLÍTICA DE PRIVACIADADE</h3>
              <br>
              <p>
                A  (Plataforma "SIGAME", "nós" ou "nosso") valoriza a privacidade dos usuários e, por esse motivo, nesta Política de Privacidade, explicamos como utilizamos, armazenamos, compartilhamos e protegemos os dados pessoais coletados por meio do uso dos nossos serviços e soluções (denominados coletivamente como "Serviços") e das visitas aos nossos sites. Além disso, detalhamos como os titulares dos dados podem exercer os direitos garantidos pela legislação aplicável.
              </p>
              <br>

              <p>
                <strong>ACEITE DESTA POLÍTICA</strong>
              </p>
              <p>
                O aceite aos termos desta política ocorrerá quando você acessar ou usar o site, software, plataforma, aplicativo ou serviços da Sigame Digital. Ao acessar ou utilizar estes serviços, você declara que está ciente e de acordo com os termos e condições previstos neste documento.
              </p>
              <p>
                Se você não concordar com algum dos termos e condições aqui previstos, você não deverá utilizar nosso produto, neste caso você poderá entrar em contato conforme previsto na seção Contato no final deste documento.
              </p>
              <br>

              <p>
                <strong>QUAIS DADOS COLETAMOS</strong>
              </p>
              <p>
                Através da plataforma "SIGAME", quando um cliente (ou para os fins desta seção, “você”) ou a sua empresa contrata, utiliza ou interage com os nossos serviços, nós coletamos os seus dados pessoais e/ou jurídicos. Esses dados podem ser divididos em três categorias:
              </p>
              <p>
                <strong>Dados que você nos fornece:</strong> quando você se registra para um serviço, assina um plano na plataforma ou entra em contato conosco, você pode nos fornecer dados como seu nome, endereço de e-mail, cpf, cnpj, telefone, endereço e dados de pagamento.
              </p>
              <p>
                <strong>Dados que coletamos automaticamente:</strong> quando você usa nossos serviços, nós podemos coletar dados sobre você automaticamente, como sistema operacional, seu endereço IP, tipo de navegador, páginas visitadas, links clicados e outros dados de navegação.
              </p>
              <p>
                <strong>Dados que coletamos de outras fontes:</strong> nós também podemos coletar dados sobre você de outras fontes, como bases de dados públicos, perfis públicos em redes sociais e entidades de proteção ao crédito.
              </p>
              <br>

              <p>
                <strong>COMO UTILIZAMOS OS DADOS COLETADOS</strong>
              </p>
              <p>
                Utilizamos as informações coletadas ou recebidas durante o uso dos nossos serviços para as finalidades abaixo:
              </p>
              <p>
                <strong>Cumprir com nossas obrigações contratuais:</strong> usamos seus dados para cumprir nossas obrigações contratuais com você, como fornecer nossos serviços, cobrar você pelos serviços que você contratou e resolver quaisquer problemas que você possa ter com nossos serviços.
              </p>
              <p>
                <strong>Notificar sobre alterações em nossos produtos e serviços:</strong> usamos seus dados para notificá-lo sobre alterações em nossos produtos e serviços, como novos recursos, atualizações de segurança e alterações nos preços.
              </p>
              <p>
                <strong>Realizar operações internas:</strong> usamos seus dados para realizar operações internas, como suporte ao cliente, solução de problemas e análise de dados.
              </p>
              <p>
                <strong>Fornecer informações sobre outros serviços e/ou produtos:</strong> usamos seus dados para fornecer informações sobre outros serviços e/ou produtos que oferecemos, similares aos já contratados por você.
              </p>
              <p>
                <strong>Analisar a publicidade que veiculamos:</strong> usamos seus dados para avaliar ou entender a eficácia da publicidade que veiculamos, visando fornecer publicidades relevantes para você.
              </p>
              <p>
                <strong>Monitorar atividades potencialmente ilegais ou proibidas:</strong> usamos seus dados para gerenciar riscos e detectar, prevenir e/ou remediar fraudes ou outras atividades potencialmente ilegais ou proibidas, além de violações de políticas, contratos ou termos de uso aplicáveis.
              </p>
              <p>
                <strong>Responder demandas judiciais, administrativos ou arbitrais:</strong> usamos seus dados conforme necessário, para estabelecer, exercer e defender direitos em processos judiciais, administrativos ou arbitrais.
              </p>
              <p>
                <strong>Cumprir com obrigações legais ou regulatórias:</strong> usamos seus dados para cumprir com obrigações legais ou regulatórias, ou conforme exigido em um processo judicial, por qualquer órgão de aplicação da lei ou do governo com competência, ou que alegue ter competência, sobre a SIGAME DIGITAL NFE.
              </p>
              <br>

              <p>
                <strong>COMPARTILHAMENTO DOS DADOS</strong>
              </p>
              <p>
                Podemos compartilhar as informações pessoais coletadas com outras empresas pertencentes ao mesmo grupo econômico, terceiros e parceiros de negócios relevantes, a fim de viabilizar a prestação dos serviços. Esse compartilhamento é baseado nos critérios e para as finalidades descritas abaixo:
              </p>
              <p>
                <strong>Entidades de proteção ao crédito:</strong> podemos compartilhar suas informações cadastrais com entidades dedicadas à redução do risco de crédito e à proteção de empresas e indivíduos contra fraudes, a fim de validar as informações fornecidas por você.
              </p>
              <p>
                <strong>Órgãos reguladores, autoridades judiciais ou administrativas:</strong> podemos compartilhar suas informações pessoais com as autoridades competentes, fornecendo todas as informações solicitadas em relação a você e às operações realizadas nos sites. Além disso, podemos compartilhar seus dados pessoais com autoridades públicas ou entidades privadas para combater fraudes e abusos no uso dos serviços, investigar suspeitas de violações da lei ou combater qualquer outra suspeita de violação de nossas políticas e contratos.
              </p>
              <p>
                <strong>Transferência de ativos:</strong> se a empresa ou unidade de negócios da SIGAME DIGITAL NFE for reorganizada ou vendida, e todos ou substancialmente todos os ativos forem transferidos a um novo proprietário, suas informações pessoais podem ser transferidas ao comprador, independentemente de sua autorização, para garantir a continuidade dos serviços.
              </p>
              <p>
                <strong>Com sua autorização:</strong> em casos não previstos acima, nos quais haja a necessidade de compartilhar dados pessoais e informações, enviaremos uma notificação com informações sobre tal compartilhamento para solicitar seu consentimento, para uma finalidade específica.
              </p>
              <br>

              <p>
                <strong>COOKIES E TECNOLOGIAS DE RASTREAMENTO</strong>
              </p>
              <p>
                Utilizamos cookies e outras tecnologias de rastreamento para coletar informações sobre o uso de nossos Serviços. Essas tecnologias nos permitem melhorar sua experiência de navegação, personalizar o conteúdo e anúncios, analisar o desempenho do site e prevenir fraudes e atender a outras finalidades legítimas.
              </p>
              <br>

              <p>
                <strong>SEUS DIREITOS</strong>
              </p>
              <p>
                Você tem direito a solicitar acesso, correção, exclusão e portabilidade dos seus dados pessoais, conforme previsto na legislação aplicável. Também pode revogar o consentimento para o tratamento de seus dados pessoais, quando o consentimento for a base legal para o tratamento. Para exercer seus direitos ou obter mais informações sobre o tratamento de seus dados pessoais, entre em contato conosco através dos canais de atendimento.
              </p>
              <br>

              <p>
                <strong>PROTEÇÃO DOS DADOS PESSOAIS</strong>
              </p>
              <p>
                Implementamos medidas de segurança físicas, técnicas e organizacionais para proteger seus dados pessoais contra acesso não autorizado, uso indevido, alteração ou divulgação.
              </p>
              <p>
                Garantimos a confidencialidade e integridade dos seus dados pessoais, adotando as melhores práticas de segurança da informação em especial no que diz respeito aos dados pessoais, de acordo com os fundamentos, princípios e demais disposições previstas na <strong>LGPD – Lei Geral de Proteção de Dados</strong> e demais legislação aplicável.
              </p>
              <br>

              <p>
                <strong>MUDANÇAS NA POLÍTICA DE PRIVACIADADE</strong>
              </p>
              <p>
                Reservamos o direito de alterar esta política de privacidade periodicamente sempre que entender necessário para cumprir as finalidades previstas. A data da última atualização sempre estará prevista na parte final do documento. Caso haja alguma mudança substancial na forma de utilização das suas informações, iremos notificá-lo com um anúncio em destaque em nosso site.
              </p>
              <br>

              <p>
                <strong>CONTATO</strong>
              </p>
              <p>
                Se você tiver alguma dúvida sobre esta Política de Privacidade ou sobre o tratamento de seus dados pessoais, entre em contato conosco através dos canais de atendimento.
              </p>
              <br>

              <p><strong>Última atualização: 01 de agosto de 2023.</strong></p>
            </div>

            <div>
              <a class="getstarted align-items-center justify-content-center" href="/">Voltar</a>
            </div>

          </div>

        </div>

      </div>
  </section>

</template>

<script>
export default {
  name: 'PoliticaComp'
}
</script>

<style scoped lang="scss">
.politica-privacidade {
  padding-top: 0;
  background-color: #f7f8fa;
  padding: 5vh 1vw;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.politica-privacidade .icon-box {
  padding: 30px;
  position: relative;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 0 29px 0 rgba(68, 88, 144, 0.12);
  transition: box-shadow 0.3s ease;
  border-radius: 8px; /* 40px; */
  z-index: 1;
}

.politica-privacidade.content {
  padding: 0;
}

.politica-privacidade.content h3 {
  font-weight: 700;
  font-size: 34px;
  color: $color-base;
}

.politica-privacidade.content p {
  margin-bottom: 0;
}
</style>
